import React from 'react';
import { View } from '@react-pdf/renderer';

import { isStatementAssessmentQuestion } from '../../../../lib/assessments';
import { LibraryFormQuestion } from '../helpers';
import BlankQuestionField from './BlankQuestionField';

interface BlankQuestionsSectionProps {
  questions: LibraryFormQuestion[] | undefined;
}

const BlankQuestionsSection: React.FC<BlankQuestionsSectionProps> = ({
  questions,
}) => {
  if (!questions?.length) {
    return null;
  }

  let questionNumber = 0;

  return (
    <View>
      {questions.map((question, index) => {
        if (!isStatementAssessmentQuestion(question)) {
          questionNumber += 1;
        }

        return (
          <BlankQuestionField
            key={index}
            question={question}
            questionNumber={
              isStatementAssessmentQuestion(question)
                ? undefined
                : questionNumber
            }
          />
        );
      })}
    </View>
  );
};

export default BlankQuestionsSection;
